import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {AccountCreditCardsPanel} from "../../common/credit-cards-panel/credit-cards-panel";
import {WalletLayout}            from "../common/wallet-layout";

export const AccountCreditCardsRoute = ({}) => cs(
    ({}, next) => WalletLayout({activeTab: "credit-cards", next}),
    consumeContext("apis"),

    ({apis}) => AccountCreditCardsPanel({
        apis: {
            getList: () => apis.next.creditCard.getCreditCards(),
            addUpdate: (card) => apis.next.creditCard.addUpdate(card),
            deleteCard: (cardToken) => apis.next.creditCard.deleteCard(cardToken),
            makeCardDefault: (cardToken) => apis.next.creditCard.makeCardDefault(cardToken),
        },
    }),
);

